export default __webpack_public_path__ + "static/media/DTEX-UC3-Seq4-Report-PDF-Pg8.341f0e92.png";